import React, { useState } from "react";
import SearchIcon from "@material-ui/icons/Search";
import { css } from "styled-components/macro";
import Input from "@material-ui/core/Input";
import { Close } from "@material-ui/icons";
import { IconButton } from "@material-ui/core";
import { primaryColor } from "../themes/default";

export function SearchForm(props: {
  query: string;
  onSearch: (query: string) => void;
}) {
  const [searchQuery, setSearchQuery] = useState(props.query);

  return (
    <div
      css={css`
        display: flex;
        justify-content: flex-end;
      `}
    >
      <div
        css={css`
          position: relative;
          width: 100%;
          max-width: 400px;
          padding-right: 70px;
        `}
      >
        <Input
          placeholder="Search"
          disableUnderline
          type="text"
          value={searchQuery}
          onChange={(e) => {
            setSearchQuery(e.target.value);
          }}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();

              props.onSearch(searchQuery);
            }
          }}
          css={css`
            width: 100%;
            height: 35px;
            border-radius: 5px;
            padding: 0 10px;
            background: #eee;
            border: none;
            outline: none;
          `}
          endAdornment={
            searchQuery ? (
              <IconButton
                onClick={() => {
                  setSearchQuery("");
                  props.onSearch("");
                }}
              >
                <Close />
              </IconButton>
            ) : null
          }
        />
        <button
          css={css`
            position: absolute;
            top: 0;
            bottom: 0;
            right: 10px;
            padding: 5px 15px;
            margin: auto;
            background: ${primaryColor};
            border-radius: 5px;
            border: none;
            outline: none;
            cursor: pointer;
          `}
          onClick={() => {
            props.onSearch(searchQuery);
          }}
        >
          <SearchIcon htmlColor="#fff" />
        </button>
      </div>
    </div>
  );
}
